require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-jkhvlhb.json") })
        }
      }, "path---project-jkhvlhb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-jkhvlhb!./.cache/json/project-jkhvlhb.json
// module id = 571
// module chunks = 231608221292675